/* eslint-disable camelcase */

module.exports = {
	methods: {
		summaries() {
			const self = this;

			return {
				async get({ id, see_future = 0 }) {
					try {
						const response = await self.$http.get(
							`summaries/${id}`, {
								params: {
									see_future,
								},
								headers: {
									Authorization: false,
								},
							},
						);

						const summaries = [];
						response.data.summaries.results.forEach((item) => {
							summaries.push({
								...item,
								deals: self.helpers().formatDeals(item.deals),
							});
						});

						if (summaries.length > 0) {
							return {
								ok: true,
								data: summaries[0],
							};
						}
						return {
							ok: false,
							data: [],
						};
					} catch (error) {
						return {
							ok: false,
							data: [],
						};
					}
				},
				async list({ offset = 0, limit = self.limit, see_future = null }) {
					try {
						if (limit > 10) limit = 10;

						const response = await self.$http.get(
							'summaries', {
								params: {
									offset,
									limit,
									see_future,
								},
								headers: {
									Authorization: false,
								},
							},
						);

						const summaries = [];
						response.data.summaries.results.forEach((item) => {
							summaries.push({
								...item,
								deals: self.helpers().formatDeals(item.deals),
							});
						});

						return {
							ok: true,
							subscribed: response.data.subscribed ? response.data.subscribed : false,
							data: {
								results: summaries,
								total: response.data.summaries.total,
							},
							error: null,
						};
					} catch (error) {
						console.log(error);
						return {
							ok: false,
							subscribed: false,
							data: [],
							error: null,
						};
					}
				},
				async subscribe() {
					try {
						await self.$http.put(
							'summaries/subscription', null, {
								headers: {
									Authorization: true,
								},
							},
						);

						self.resetStatus();

						return true;
					} catch (error) {
						self.resetStatus();
						return false;
					}
				},
				async unsubscribe() {
					try {
						await self.$http.delete(
							'summaries/subscription', null, {
								headers: {
									Authorization: true,
								},
							},
						);

						self.resetStatus();

						return true;
					} catch (error) {
						self.resetStatus();
						return false;
					}
				},
				async add({ text, deals, created_at = null }) {
					try {
						const params = {
							text,
							deals,
						};

						if (created_at) params.created_at = created_at;

						const response = await self.$http.post(
							'admin/summaries', params, {
								headers: {
									Authorization: true,
								},
							},
						);

						self.resetStatus();

						return {
							ok: true,
							id: response.data.summary_id,
						};
					} catch (error) {
						self.resetStatus();

						return {
							ok: false,
						};
					}
				},
				async edit(id, { text, deals, created_at = null }) {
					try {
						const params = {
							text,
							deals,
						};

						if (created_at) params.created_at = created_at;

						await self.$http.patch(
							`admin/summaries/${id}`, params, {
								headers: {
									Authorization: true,
								},
							},
						);

						self.resetStatus();

						return { ok: true };
					} catch (error) {
						self.resetStatus();
						return { ok: false };
					}
				},
				async del(id) {
					try {
						await self.$http.delete(
							`admin/summaries/${id}`, {
								headers: {
									Authorization: true,
								},
							},
						);

						self.resetStatus();

						return true;
					} catch (error) {
						self.resetStatus();
						return false;
					}
				},
			};
		},
	},
};
